import { Link } from "react-router-dom";

const renderInline = (text, keyPrefix) => {
  const parts = [];
  const re = /\*\*(.+?)\*\*|\[([^\]]+)\]\(([^)]+)\)/g;
  let last = 0;
  let m;
  let i = 0;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    if (m[1] !== undefined) {
      parts.push(<strong key={`${keyPrefix}-b${i}`} className="font-semibold text-[#0A1128]">{m[1]}</strong>);
    } else if (m[3].startsWith("/")) {
      parts.push(<Link key={`${keyPrefix}-l${i}`} to={m[3]} className="text-[#0A1128] underline decoration-[#C4C8CC] underline-offset-4 hover:decoration-[#0A1128] transition-colors duration-200">{m[2]}</Link>);
    } else {
      parts.push(<a key={`${keyPrefix}-a${i}`} href={m[3]} target="_blank" rel="noopener noreferrer" className="text-[#0A1128] underline decoration-[#C4C8CC] underline-offset-4">{m[2]}</a>);
    }
    last = re.lastIndex;
    i += 1;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
};

export const MarkdownLite = ({ text = "", className = "" }) => {
  const blocks = text.split(/\n\s*\n/).map((b) => b.trim()).filter(Boolean);
  return (
    <div className={`space-y-4 text-[15px] sm:text-base text-[#374151] leading-relaxed ${className}`}>
      {blocks.map((block, bi) => {
        const lines = block.split("\n");
        if (block.startsWith("### ")) {
          return <h3 key={bi} className="text-base md:text-lg font-bold text-[#0A1128] pt-2">{renderInline(block.slice(4), `h${bi}`)}</h3>;
        }
        if (lines.every((l) => l.startsWith("- "))) {
          return (
            <ul key={bi} className="space-y-2 pl-1">
              {lines.map((l, li) => (
                <li key={li} className="flex gap-3"><span className="mt-[9px] h-1.5 w-1.5 rounded-full bg-[#0A1128] shrink-0" /><span>{renderInline(l.slice(2), `${bi}-${li}`)}</span></li>
              ))}
            </ul>
          );
        }
        if (lines.every((l) => /^\d+\.\s/.test(l))) {
          return (
            <ol key={bi} className="space-y-2 pl-1">
              {lines.map((l, li) => (
                <li key={li} className="flex gap-3"><span className="font-heading text-lg text-[#9CA3AF] leading-6 w-5 shrink-0">{li + 1}</span><span>{renderInline(l.replace(/^\d+\.\s/, ""), `${bi}-${li}`)}</span></li>
              ))}
            </ol>
          );
        }
        return <p key={bi}>{renderInline(lines.join(" "), `p${bi}`)}</p>;
      })}
    </div>
  );
};
